// wageRate.js (Service File)
import axiosInstance from "../Axios";

function getWageRates(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }
    return axiosInstance.get("/payroll/wage-rates", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching wage rates:", error);
    throw error;
  }
}

function getWageRateDetails(id) {
  try {
    return axiosInstance.get(`/payroll/wage-rates/${id}`);
  } catch (error) {
    console.log("Error fetching wage rate details:", error);
    throw error;
  }
}

function createWageRate(data) {
  try {
    return axiosInstance.post("/payroll/wage-rates", data);
  } catch (error) {
    console.log("Error while creating wage rate:", error);
    throw error;
  }
}

function updateWageRate(id, data) {
  try {
    return axiosInstance.put(`/payroll/wage-rates/${id}`, data);
  } catch (error) {
    console.log("Error while updating wage rate:", error);
    throw error;
  }
}

function deleteWageRate(id) {
  try {
    return axiosInstance.delete(`/payroll/wage-rates/${id}`);
  } catch (error) {
    console.log("Error while deleting wage rate:", error);
    throw error;
  }
}

export { getWageRates, getWageRateDetails, createWageRate, updateWageRate, deleteWageRate };
